module.exports = {
  GT: "gt",
  LT: "lt",
  EQ: "eq",
  NOT_EQ: "neq",
  IN: "in",
  GTE: "geq",
  LTE: "leq",
};
